import React from "react";
import { Check, X, HelpCircle } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./ui/tooltip";

function fmtDay(d) {
  return d.toISOString().split("T")[0];
}
function labelBR(d) {
  return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" });
}

export default function StreakCalendar({ studiedDates = [] }) {
  const set = new Set(studiedDates);
  const days = [];
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  for (let i = 29; i >= 0; i--) {
    const d = new Date(today);
    d.setDate(today.getDate() - i);
    days.push(d);
  }

  // Compute streak-without-fail
  let daysWithoutStudy = 0;
  for (let i = days.length - 1; i >= 0; i--) {
    if (!set.has(fmtDay(days[i]))) daysWithoutStudy++;
    else break;
  }

  const startLabel = labelBR(days[0]);
  const endLabel = labelBR(days[days.length - 1]);

  return (
    <div className="rounded-2xl bg-card border border-border p-5 md:p-6">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-2">
          <h3 className="font-display font-bold text-sm uppercase tracking-wider text-muted-foreground">Constância nos Estudos</h3>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <HelpCircle size={14} className="text-muted-foreground" />
              </TooltipTrigger>
              <TooltipContent>
                <p>Marque estudos diários para manter sua sequência.</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <div className="text-xs text-muted-foreground font-semibold">
          {startLabel} ~ {endLabel}
        </div>
      </div>
      <p className="text-sm mb-4">
        {daysWithoutStudy > 0 ? (
          <>Você está há <strong>{daysWithoutStudy} dias</strong> sem estudar!</>
        ) : (
          <>Você está estudando hoje! Continue assim.</>
        )}
      </p>
      <div className="grid grid-cols-15 gap-1.5" style={{ gridTemplateColumns: "repeat(30, minmax(0, 1fr))" }}>
        {days.map((d) => {
          const iso = fmtDay(d);
          const studied = set.has(iso);
          return (
            <TooltipProvider key={iso} delayDuration={100}>
              <Tooltip>
                <TooltipTrigger asChild>
                  <div
                    className={`h-7 w-full rounded-md flex items-center justify-center transition-transform hover:scale-110 ${
                      studied
                        ? "bg-tiffany-100 text-tiffany-600 dark:bg-tiffany-900/40 dark:text-tiffany-300"
                        : "bg-red-100 text-red-500 dark:bg-red-900/30 dark:text-red-400"
                    }`}
                  >
                    {studied ? <Check size={14} /> : <X size={14} />}
                  </div>
                </TooltipTrigger>
                <TooltipContent>
                  <p>{labelBR(d)} — {studied ? "Estudou" : "Sem registro"}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          );
        })}
      </div>
    </div>
  );
}
